import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectionIntersectIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <rect x="2" y="2" width="8" height="8" stroke={color} strokeWidth="1.5" fill="none" />
      <rect x="6" y="6" width="8" height="8" stroke={color} strokeWidth="1.5" fill="none" />
      <rect x="6" y="6" width="4" height="4" fill={color} />
    </BaseIcon>
  ),
);

SelectionIntersectIcon.displayName = 'SelectionIntersectIcon';
